import gql from 'graphql-tag';

export const SELLER_BRAND_PORTFOLIO_FRAGMENT = gql`
    fragment SellerBrandPortfolio on SellerBrandPortfolio {
        id
        createdAt
        updatedAt
        channel {
            id
            code
            defaultLanguageCode
        }
        facetValue {
            id
            code
        }
    }
`;

export const GET_SELLER_BRANDS_BY_CHANNEL = gql`
    query GetSellerBrandsByChannel($sellerId: ID!, $channelId: ID!) {
        sellerBrandsByChannel(sellerId: $sellerId, channelId: $channelId) {
            ...SellerBrandPortfolio
        }
    }
    ${SELLER_BRAND_PORTFOLIO_FRAGMENT}
`;

export const GET_ADMINISTRATOR_WITH_BRANDS = gql`
    query GetAdministratorWithBrands($id: ID!) {
        administrator(id: $id) {
            id
            firstName
            lastName
            emailAddress
            brandPortfolio {
                ...SellerBrandPortfolio
            }
        }
    }
    ${SELLER_BRAND_PORTFOLIO_FRAGMENT}
`;

export const GET_FACET_VALUES_FOR_MARCA = gql`
    query GetFacetValuesForMarca {
        facets {
            id
            code
            values {
                id
                code
            }
        }
    }
`;

export const ADD_SELLER_BRAND = gql`
    mutation AddSellerBrand(
        $sellerId: ID!
        $channelId: ID!
        $facetValueId: ID!
    ) {
        addSellerBrand(
            sellerId: $sellerId
            channelId: $channelId
            facetValueId: $facetValueId
        ) {
            ...SellerBrandPortfolio
        }
    }
    ${SELLER_BRAND_PORTFOLIO_FRAGMENT}
`;

export const REMOVE_SELLER_BRAND = gql`
    mutation RemoveSellerBrand(
        $sellerId: ID!
        $channelId: ID!
        $facetValueId: ID!
    ) {
        removeSellerBrand(
            sellerId: $sellerId
            channelId: $channelId
            facetValueId: $facetValueId
        )
    }
`;

export const UPDATE_SELLER_BRANDS = gql`
    mutation UpdateSellerBrands(
        $sellerId: ID!
        $channelId: ID!
        $facetValueIds: [ID!]!
    ) {
        updateSellerBrands(
            sellerId: $sellerId
            channelId: $channelId
            facetValueIds: $facetValueIds
        ) {
            ...SellerBrandPortfolio
        }
    }
    ${SELLER_BRAND_PORTFOLIO_FRAGMENT}
`;
